import { fetchFromBookingAPI } from '@/api/baseAPI';
import { BaseProperty } from '@/features/property/types';
import { RealtimeCompetitor, RealtimeProperty } from '../types';
import { DeviceType } from '@/features/charts/api/fetchChartData';

export interface SearchPropertiesResponse {
  results: Array<{
    property_id: number;
    name: string;
    path: string;
    city: string;
    country_code: string;
  }>;
}

export const searchProperties = async (searchTerm: string): Promise<SearchPropertiesResponse> => {
  const response = await fetchFromBookingAPI(`search-properties/?q=${encodeURIComponent(searchTerm)}`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  return response.json();
};


export interface RealtimeFilterValues {
  length_of_stay?: number;
  adults?: number;
  rooms?: number;
  days?: number;
  device_type?: DeviceType;
}

export interface RealtimeChartDataResponse {
  property: RealtimeProperty;
  competitors: RealtimeCompetitor[];
  market_properties: BaseProperty[];
  filters: RealtimeFilterValues;
}

export const getPropertyChartDataRealtime = async (propertyId: number, params: RealtimeFilterValues = {}): Promise<RealtimeChartDataResponse> => {
  // Filter out undefined values and convert to strings
  const queryParams = new URLSearchParams(
    Object.entries(params)
      .filter(([_, value]) => value !== undefined)
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value.toString() }), {})
  );

  const response = await fetchFromBookingAPI(`property-charts-realtime/${propertyId}?${queryParams}`, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  return data
};